import { Directive } from '@angular/core';

@Directive({
  selector: '[appButton]',
  host: { class: 'app-button app-raised-button' },
})
export class ButtonDirective {}

@Directive({
  selector: '[appRaisedButton]',
  host: { class: 'app-button app-raised-button' },
})
export class RaisedButtonDirective {}

@Directive({
  selector: '[appStrokedButton]',
  host: { class: 'app-button app-stroked-button' },
})
export class StrokedButtonDirective {}

@Directive({
  selector: '[appIconButton]',
  host: { class: 'app-button app-icon-button' },
})
export class IconButtonDirective {}

@Directive({
  selector: '[appSmallButton]',
  host: { class: 'app-small-button' },
})
export class SmallButtonDirective {}

@Directive({
  selector: '[appLargeButton]',
  host: { class: 'app-large-button' },
})
export class LargeButtonDirective {}
